import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import CircleIcon from '/@/components/circle-icon';
import styles from './styles.module.css';

@autobind
export default class Card extends Component {
    static propTypes = {
        title: PropTypes.string,
        subtitle: PropTypes.string,
        children: PropTypes.node,
        disabled: PropTypes.bool,
        theme: PropTypes.string,
        icon: PropTypes.oneOf(['corn', 'soy', 'weeds', 'pest', 'disease']),
        underlineHeader: PropTypes.bool,
        noBottomPadding: PropTypes.bool,
        maxWidth: PropTypes.bool,
        noBorder: PropTypes.bool,
    };

    static defaultProps = {
        maxWidth: true,
    };

    static contextTypes = {
        theme: PropTypes.string,
        getTheme: PropTypes.func,
    };

    static childContextTypes = {
        theme: PropTypes.string,
    };

    getChildContext() {
        return { theme: this.getTheme() };
    }

    getTheme() {
        return this.props.theme || this.context.theme;
    }

    renderHeader() {
        if (!this.props.icon && !this.props.number && !this.props.title) return;

        return (
            <div className={styles.header}>
                {this.props.icon && !this.props.number && <CircleIcon icon={this.props.icon} className={styles.icon} />}
                {this.props.number && !this.props.icon && (
                    <div className={classNames(styles.number, styles[this.getTheme()])}>{this.props.number}</div>
                )}
                {this.props.title && <div className={styles.title}>{this.props.title}</div>}
                {this.props.subtitle && <div className={styles.subtitle}>{this.props.subtitle}</div>}
            </div>
        );
    }

    render() {
        const rootClassName = classNames(styles.root, {
            [styles.hasIcon]: this.props.icon,
            [styles.hasNumber]: this.props.number,
            [styles.maxWidth]: this.props.maxWidth,
        });

        const cardClassName = classNames(styles.card, styles[this.props.theme], {
            [styles.disabled]: this.props.disabled,
            [styles.underlineHeader]: this.props.underlineHeader,
            [styles.noBottomPadding]: this.props.noBottomPadding,
            [styles.clickable]: this.props.onClick && !this.props.noBorder,
            [styles.clickableNoBorder]: this.props.noBorder,
        });

        return (
            <div className={rootClassName}>
                <div className={cardClassName} onClick={this.props.onClick}>
                    {this.renderHeader()}
                    {!this.props.disabled && this.props.children}
                </div>
            </div>
        );
    }
}
